export enum GESTION_PRODUCTOS_TYPES {
  // * --------------------------------------------------------------
  // * TYPES PARA LA CREACIÓN DE PRODUCTO = CP
  // * --------------------------------------------------------------
  CP_FORM_HANDLE_CHANGE = 'CP_FORM_HANDLE_CHANGE',
  CP_FORM_ADD_ERROR = 'CP_FORM_ADD_ERROR',
  CP_FORM_CHANGE_PAGE = 'CP_FORM_CHANGE_PAGE',
  CP_FORM_CLEAR = 'CP_FORM_CLEAR',
  CP_SHOW_MODAL_CONFIRMACION = 'CP_SHOW_MODAL_CONFIRMACION',
  CP_SHOW_MODAL_CREADO = 'CP_SHOW_MODAL_CREADO',
  CP_SET_SUCURSALES = 'CP_SET_SUCURSALES',
  CP_SET_SUCURSALES_ASIGNADAS = 'CP_SET_SUCURSALES_ASIGNADAS',
  CP_SET_ID_PRODUCTO_CREADO = 'CP_SET_ID_PRODUCTO_CREADO',
  CP_FORM_CLEAR_FORM_ONLY = 'CP_FORM_CLEAR_FORM_ONLY',
  CP_SHOW_MODAL_VALIDACIONES = 'CP_SHOW_MODAL_VALIDACIONES',
  // * --------------------------------------------------------------
  // * TYPES PARA LA LISTA DE PRODUCTOS = LP
  // * --------------------------------------------------------------
  LP_SET_ARRAY_PRODUCTOS = 'LP_SET_ARRAY_PRODUCTOS',
  LP_SET_PRODUCTOS = 'LP_SET_PRODUCTOS',
  LP_FORM_BUSCAR = 'LP_FORM_BUSCAR',
  LP_CLEAR = 'LP_CLEAR',
  LP_SHOW_MODAL_ESTATUS = 'LP_SHOW_MODAL_ESTATUS',
  LP_SHOW_MODAL_ELIMINAR_PRODUCTO = 'LP_SHOW_MODAL_ELIMINAR_PRODUCTO',
  LP_SHOW_MODAL_SUCURSALES = 'LP_SHOW_MODAL_SUCURSALES',
  LP_SET_PRODUCTO_SELECCIONADO = 'LP_SET_PRODUCTO_SELECCIONADO',
  LP_CLEAR_FORM_BUSCAR = 'LP_CLEAR_FORM_BUSCAR',
  LP_SET_SUCURSALES = 'LP_SET_SUCURSALES',
  LP_SET_SUCURSALES_ASIGNADAS = 'LP_SET_SUCURSALES_ASIGNADAS',

  // * --------------------------------------------------------------
  // * TYPES PARA EDITAR PRODUCTO = EP
  // * --------------------------------------------------------------
  EP_FORM_EDITAR_HANDLE_CHANGE = 'EP_FORM_EDITAR_HANDLE_CHANGE',
  EP_FORM_CHANGE_PAGE = 'EP_FORM_CHANGE_PAGE',
  EP_FORM_EDITAR_ADD_ERROR = 'EP_FORM_EDITAR_ADD_ERROR',
  EP_SHOW_MODAL_ELIMINAR_PRODUCTO = 'EP_SHOW_MODAL_ELIMINAR_PRODUCTO',
  EP_SET_PRODUCTO_SELECCIONADO = 'EP_SET_PRODUCTO_SELECCIONADO',
  EP_CLEAR = 'EP_CLEAR',
  EP_FORM_CLEAR_FORM_ONLY = 'EP_FORM_CLEAR_FORM_ONLY',
  EP_SET_SUCURSALES_ASIGNADAS = 'EP_SET_SUCURSALES_ASIGNADAS',
  EP_SET_SUCURSALES = 'EP_SET_SUCURSALES',
  // * --------------------------------------------------------------
  // * TYPES PARA CATEGORÍAS Y SUCURSALES = CS
  // * --------------------------------------------------------------
  CS_SET_CATEGORIAS_LIST = 'CS_SET_CATEGORIAS_LIST',
  CS_SET_SUCURSALES_LIST = 'CS_SET_SUCURSALES_LIST',
  CS_SET_FORM_PRODUCTO = 'CS_SET_FORM_PRODUCTO',
  CS_SET_ERRORS_FORM_PRODUCTO = 'CS_SET_ERRORS_FORM_PRODUCTO',
  CS_CLEAR_FORM_PRODUCTO = 'CS_CLEAR_FORM_PRODUCTO',

  // * --------------------------------------------------------------
  // * TYPES PARA LA CARGA MASIVA
  // * --------------------------------------------------------------
  PRODUCTOS_CLEAR = 'PRODUCTOS_CLEAR',
  PRODUCTOS_CHANGE_FORM_CARGA = 'PRODUCTOS_CHANGE_FORM_CARGA',
  PRODUCTOS_SET_FILE_DATA_CARGADA = 'PRODUCTOS_SET_FILE_DATA_CARGADA',
  PRODUCTOS_SET_DATA_PRODUCTO = 'PRODUCTOS_SET_DATA_PRODUCTO',
  PRODUCTOS_SET_PRODUCTO_ACTIVO = 'PRODUCTOS_SET_PRODUCTO_ACTIVO',
  EP_SET_FORM_PRODUCT = 'EP_SET_FORM_PRODUCT',
  
}
